/**
 * Returns:
 *  - 'normal' for old style slots - `<template slot="default">`
 *  - 'scoped' for old style scoped slots (`<template slot="default" slot-scope="data">`) or bound v-slot (`#default="data"`)
 *  - 'v-slot' for unbound v-slot (`#default`) - only if the third param is true, otherwise counts as scoped
 */
export function getSlotType<T extends boolean = false>(
  vm: Vue,
  name: string,
  split?: T
): (T extends true ? 'v-slot' : never) | 'normal' | 'scoped' | void {
  if (
    vm.$slots.hasOwnProperty(name) &&
    vm.$scopedSlots.hasOwnProperty(name) &&
    (vm.$scopedSlots[name] as any).name
  ) {
    return split ? ('v-slot' as any) : 'scoped';
  }
  if (vm.$slots.hasOwnProperty(name)) return 'normal';
  if (vm.$scopedSlots.hasOwnProperty(name)) return 'scoped';
}

export function getSlot(
  vm: Vue,
  name = 'default',
  data?: object | (() => object),
  optional = false
) {
  if (vm.$scopedSlots.hasOwnProperty(name)) {
    return vm.$scopedSlots[name]!(data instanceof Function ? data() : data);
  } else if (vm.$slots.hasOwnProperty(name) && (!data || optional)) {
    return vm.$slots[name];
  }
  return undefined;
}

export function keys<O>(o: O) {
  return Object.keys(o) as (keyof O)[];
}

export function convertToUnit(
  str: string | number | null | undefined,
  unit = 'px'
): string | undefined {
  if (str == null || str === '') {
    return undefined;
  } else if (isNaN(+str!)) {
    return String(str);
  } else {
    return `${Number(str)}${unit}`;
  }
}
export const isProd = process.env.NODE_ENV === 'production';
export const keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16,
});

export function filterObjectOnKeys<T, K extends keyof T>(
  obj: T,
  keys: K[]
): { [N in K]: T[N] } {
  const filtered = {} as { [N in K]: T[N] };

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (typeof obj[key] !== 'undefined') {
      filtered[key] = obj[key];
    }
  }

  return filtered;
}

export function getZIndex(el?: Element | null): number {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;

  const index = +window.getComputedStyle(el).getPropertyValue('z-index');

  if (!index) return getZIndex(el.parentNode as Element);
  return index;
}



// WEBPACK FOOTER //
// ./src/uikit/utils/helpers.ts